import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import CheckoutSuccess from "../../pages/CheckoutSuccess";

export const Route = createFileRoute("/checkout/success")({
	validateSearch: z.object({ session_id: z.string().optional() }),
	component: CheckoutSuccess,
});
